/**
 * Google's required attribution when the reCAPTCHA badge is hidden
 * (index.css hides `.grecaptcha-badge`). Render it once, under any form
 * that requests a reCAPTCHA token: signup, send-OTP, virtual-office intake.
 * https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-badge.-what-is-allowed
 */
export default function RecaptchaNotice({ className = "" }) {
  return (
    <p className={`text-xs text-space-50 ${className}`}>
      This site is protected by reCAPTCHA and the Google{" "}
      <a
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        Privacy Policy
      </a>{" "}
      and{" "}
      <a
        href="https://policies.google.com/terms"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        Terms of Service
      </a>{" "}
      apply.
    </p>
  );
}
